import { render, staticRenderFns } from "./logistics_management.vue?vue&type=template&id=4d2c6841"
import script from "./logistics_management.vue?vue&type=script&lang=js"
export * from "./logistics_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports